import { roundUpDispenseAmount } from './roundUpDispenseAmount';

/** A dispense amount as it reads on the pad, rounded up at the first decimal: a whole number shows no decimal place */
export const formatDispenseAmount = (amount: number) => roundUpDispenseAmount(amount).toFixed();
